import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs3 from "./page_us/Solution-US-3/SectionUs3.js";
import { useEffect } from "react";



const PlafondsMursTendus = () =>{
   useEffect(() => {
  const previousTitle = document.title;
  const pageUrl = "https://unik-system.com/parking-ombrage-abri-voiture-maroc";
  const imageUrl =
    "https://unik-system.com/static/media/image(3).e07612c5ddd51e716df3.webp";

  const manageTag = (name, content, isProperty = false) => {
    const attr = isProperty ? "property" : "name";
    let tag = document.querySelector(`meta[${attr}='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute(attr, name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content.trim().replace(/\s+/g, " "));
  };

  // ========= TITLE =========
  document.title =
    "Ombrière Parking Maroc | Abri Voiture & Solaire – UNIK SYSTEM";

  // ========= META =========
  manageTag(
    "description",
    "Ombrières de parking au Maroc : abri voiture, structure solaire et ombrage professionnel pour entreprises et villas."
  );

  manageTag(
    "keywords",
    "ombriere parking maroc, abri voiture maroc, parking solaire maroc, carport maroc"
  );

  manageTag("robots", "index, follow");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.rel = "canonical";
    document.head.appendChild(canonical);
  }
  canonical.href = pageUrl;

  // ========= OPEN GRAPH =========
  manageTag("og:title", document.title, true);
  manageTag(
    "og:description",
    "Solutions d’ombrières de parking et abris voiture au Maroc.",
    true
  );
  manageTag("og:image", imageUrl, true);
  manageTag("og:url", pageUrl, true);
  manageTag("og:type", "website", true);

  // ========= SCHEMA CLEAN =========
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        name: "UNIK SYSTEM",
        url: "https://unik-system.com",
        image: imageUrl,
        address: {
          "@type": "PostalAddress",
          addressLocality: "Casablanca",
          addressCountry: "MA"
        },

        // ⭐ IMPORTANT
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.9",
          reviewCount: "18"
        },

        review: [
          {
            "@type": "Review",
            author: {
              "@type": "Person",
              name: "Client Maroc"
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "5"
            },
            reviewBody:
              "Installation rapide et qualité excellente pour ombrière parking."
          }
        ]
      },

      {
        "@type": "Service",
        name: "Ombrière parking Maroc",
        description:
          "Installation d’ombrières de parking, carport et structures solaires.",
        provider: {
          "@type": "Organization",
          name: "UNIK SYSTEM"
        },
        areaServed: {
          "@type": "Country",
          name: "Morocco"
        }
      },

      {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Accueil",
            item: "https://unik-system.com"
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Ombrière parking",
            item: pageUrl
          }
        ]
      }
    ]
  };

  let script = document.querySelector("#schema-clean");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-clean";
    document.head.appendChild(script);
  }

  script.innerHTML = JSON.stringify(schema);

  return () => {
    document.title = previousTitle;
    if (script) script.remove();
  };
}, []);


  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs3/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;